import { useEffect, useState } from "react";
import { Button, Message, Modal } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import AddLicenceForm, { FormData } from "./AddLicenceForm";
import { LicenceProduct } from "../models/LicenceProduct";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (productName: string, totalPrice: number, numberOfUsers: number, licenceType: string) => void;
  submitInProgress: boolean;
  submitErrors?: string[];
  products?: LicenceProduct[] | null;
}

const ChangeLicenceProductModal = ({ open, onClose, onSubmit, submitInProgress, submitErrors, products }: Props) => {
  const [formData, setFormData] = useState<FormData>({} as FormData);
  const [formErrors, setFormErrors] = useState<FormError>({});
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    setFormData({} as FormData);
    setFormErrors({} as FormError);
    setHasSubmitted(false);
  }, [open]);

  const validateFormData = (formData: FormData) => {
    const formError: FormError = {};

    if (!formData.numberOfUsers) {
      formError.numberOfUsers = "Please enter number of users";
    }

    return formError;
  };

  const handleSubmit = () => {
    setHasSubmitted(true);

    const validationErrors = validateFormData(formData);
    setFormErrors(validationErrors);

    // If there is no validation error
    if (Object.keys(validationErrors).length === 0) {
      const { productName, totalPrice, numberOfUsers, licenceType } = formData;
      onSubmit(productName, totalPrice, numberOfUsers, licenceType);
    }
  };

  const handleFormChange = (formData: FormData) => {
    if (hasSubmitted) {
      const validationErrors = validateFormData(formData);
      setFormErrors(validationErrors);
    }

    setFormData({ ...formData });
  };

  const handelClose = () => {
    onClose();
  };

  return (
    <Modal open={open}>
      <Modal.Header>Change licence product</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Message warning>This product will be activated after the licence renewal date.</Message>
          <AddLicenceForm
            formErrors={formErrors}
            errors={submitErrors}
            formData={formData}
            onChange={handleFormChange}
            products={products}
          ></AddLicenceForm>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handelClose}>Cancel</Button>
        <Button onClick={handleSubmit} positive loading={submitInProgress} disabled={submitInProgress}>
          Ok
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ChangeLicenceProductModal;
